export const SGGraphics = {
    MatrixContent: {
        disco: "disco"
    },
    MatrixBackground: {
        glow: "glow"
    }
};

export const SGLayers = {
    Sand: "Sand",
    Anticipation: "Anticipation",
    Lightening: "Lightening",
    Stickies: "Stickies"
};

export const symbolsName = {
    H1: "symbol-H1-ankh",
    H2: "symbol-H2-scarab",
    H3: "symbol-H3-eye-of-ra",
    L1: "symbol-L1-green-bowl",
    L2: "symbol-L2-gold-bowl",
    L3: "symbol-L3-bird",
    L4: "symbol-L4-sphinx",
    WILD: "wild",
    SCATTER: "symbol-scatter",
    EXPANDED_2: "expanded_2",
    EXPANDED_3: "expanded_3",
    EXPANDED_4: "expanded_4",
    EXPANDED_2_3: "expanded_2_3",
    EXPANDED_3_4: "expanded_3_4",
    EXPANDED_2_3_4: "expanded_2_3_4"
};

export const AnticipationShakeDuration = 1500;
